var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAccountBkIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5897 8.45057C11.5513 8.79683 11.46 9.10847 11.3158 9.38548C11.1813 9.6625 11.0083 9.90983 10.7969 10.1275C10.5855 10.3352 10.3452 10.5133 10.0762 10.6617C9.80708 10.8002 9.52839 10.9091 9.2401 10.9882L12.6852 15.6628H11.042L8.49052 12.1754C8.21184 11.7896 7.95717 11.5125 7.72654 11.3444C7.50551 11.1663 7.27007 11.0772 7.02021 11.0772V9.99392H7.87069C8.16859 9.99392 8.45208 9.97413 8.72116 9.93456C8.99985 9.88509 9.24971 9.80595 9.47073 9.69712C9.69176 9.5784 9.87435 9.42011 10.0185 9.22224C10.1723 9.02438 10.2636 8.76715 10.2924 8.45057H6.76074L7.19319 7.57501H10.2347C10.1482 7.16938 9.96084 6.8429 9.67254 6.59557C9.38424 6.34824 8.99504 6.21468 8.50494 6.19489H6.76074L7.19319 5.31934H13.5213L13.0889 6.19489H10.9843C11.311 6.57084 11.508 7.03088 11.5753 7.57501H13.5213L13.0889 8.45057H11.5897Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.25 10.3943C19.25 15.6865 15.0882 19.9392 10 19.9392C4.91176 19.9392 0.75 15.6865 0.75 10.3943C0.75 5.10207 4.91176 0.849365 10 0.849365C15.0882 0.849365 19.25 5.10207 19.25 10.3943Z",
    stroke: "#202124",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountBkIcon);
export default __webpack_public_path__ + "static/media/accountBkIcon.2fd49e78338a44e8c788946d16572ccb.svg";
export { ForwardRef as ReactComponent };